// src/features/media/hooks/usePlayerTime.ts

import { useState, useEffect } from 'react';
import { PostMessageUtil, PlayerMessageType } from '@lib2/model/util/browser/PostMessageUtil';
import { PlayerMessageUtil } from '@lib2/model/player/postmessage/PlayerMessageUtil';

/**
 * Hook for listening to player time updates via PostMessage.
 * The embedded player sends time_change messages as the user scrubs or plays.
 */
export function usePlayerTime() {
  const [currentTime, setCurrentTime] = useState(0);

  useEffect(() => {
    const handler = (event: MessageEvent) => {
      const msg = PlayerMessageUtil.handleMessageEvent(event, PlayerMessageType.TimeChange);
      if (msg) {
        setCurrentTime(msg.msg.second);
      }
    };

    PostMessageUtil.registerListener(handler);
    return () => PostMessageUtil.removeListener(handler);
  }, []);

  return { currentTime };
}
